import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { MdAccessTimeFilled, MdCall, MdLocationPin } from 'react-icons/md';
import Heading from '../../../components/Ui/Heading';
import ContactForm from '../../../forms/ContactForm';

const ContactUs = () => {
	return (
		<Container>
			<Heading>Contact Us</Heading>
			<Row>
				<Col md={4}>
					<Row className="text-center flex-column gy-5">
						<Col>
							<MdLocationPin style={{ fontSize: '4rem' }} />
							<div className="mt-3">
								<a
									href="#"
									rel="noreferrer noopener"
									className="text-decoration-none text-dark"
								>
									Plot- 06, Road-14, Sector-06, <br /> Uttara, Dhaka
								</a>
							</div>
						</Col>
						<Col>
							<MdCall style={{ fontSize: '4rem' }} />
							<div className="mt-3">
								<a
									href="tel:+8801756167724"
									className="text-decoration-none text-dark"
								>
									+88 01756 167724
								</a>
							</div>
						</Col>
						<Col>
							<MdAccessTimeFilled style={{ fontSize: '4rem' }} />
							<div className="mt-3">Always</div>
						</Col>
					</Row>
				</Col>
				<Col md={8}>
					<ContactForm />
				</Col>
			</Row>
		</Container>
	);
};

export default ContactUs;
